import React from 'react'
import {useNavigate} from 'react-router-dom'
import FallbackDesign from '@retracedgmbh/ui-components-lib/FallbackDesign'
const PageNotFound = () => {
  const navigate = useNavigate()
  return (
    <section className="hero is-fullheight">
      <div className="hero-body">
        <div className="container tw:text-center">
          <FallbackDesign
            icon="fa-3x fa-solid fa-heart-broken"
            title="Page Not Found"
            subTitle="We are so sorry, but the page cannot be found"
            button={{
              title: 'Return to Dashboard',
              variant: 'fill',
              color: 'primary',
              onClick: () => {
                navigate('/')
              },
            }}
          />
        </div>
      </div>
    </section>
  )
}

export default PageNotFound
